'use strict';

/**
 * Simple Legend Directive
 *
 * Renders given legend items
 *
 * @constructor
 */
var SimpleLegendDirective = function SimpleLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/simple-legend.html'),
    /**
     * @param {Object} scope
     * @param {ChartLegendItemDirective.scope.item[]} scope.legend - array of legend items
     */
    scope: {
      legend: '='
    }
  };
};
SimpleLegendDirective.$inject = [];
module.exports = SimpleLegendDirective;